import React from 'react'

import './Navbar.css'

import User from '../../assets/images/user.png'



import Cart from '../../assets/images/cart.png'
// import logoM from '../../assets/images/logoM1.jpg'
import {useCart as uCart} from '../reducer/contextReducer'

import { Link, useNavigate as Navigate } from 'react-router-dom'

// import Logo3d from '../threeD/logo'



export default function navbar() {

  let name= localStorage.getItem('userEmail')
  let data=uCart()
  
  const uNav = Navigate()

  const handleLogout = (e) => {
    e.preventDefault()
    localStorage.removeItem("userEmail")
    localStorage.removeItem("authToken")
    uNav("/login")
  }


  
  function openNav() {
    document.getElementById("mySidenav").style.width = "250px";

  }

  function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
  }
  return (
    <>



              <nav className="navbar navbar-expand-lg nav-container " >

                <div  className='d-flex justify-content-center' style={{
                  width:'300px',height:'50px'}}>

                  {/* <Link to={"/"}><Logo3d texture={logoM} /></Link> */}
                  <div id="mySidenav" className="sidenav">
                    <button type='button' className='closeBtn' onClick={closeNav}>X</button>
            <div style={{color:'white'}} className='text-center'>
                      hello <br/><img src={User} alt='' />{!localStorage.getItem("authToken") ? <><div><Link style={{ color: 'white', fontFamily: "'Orbitron', sans-serif" }} id='login' to='/login'>
                        Sign in
              </Link></div></> : <>{name}
                  <Link to='/userProfile' className="nav-link text-center logout" style={{ color: 'white', fontFamily: "'Orbitron', sans-serif" }}>My Profile</Link>
                  <Link to='/myOrders' className="nav-link text-center logout" style={{ color: 'white', fontFamily: "'Orbitron', sans-serif" }}>My Orders</Link>
              </>}
              
                    </div>

                    <div className='text-center container sideDiv ' >
                      <Link className='d-block' to={"/"}  style={{ color:'white', fontFamily: "'Orbitron', sans-serif" }}>Home </Link>
                      <Link className='d-block' to={"/about"}  style={{ color:'white', fontFamily: "'Orbitron', sans-serif" }}> About </Link>
                      <Link className='d-block' to={"/medici"}  style={{ color:'white', fontFamily: "'Orbitron', sans-serif" }}> Medicine </Link>
                      <Link className='d-block' to={"/news"}  style={{ color:'white', fontFamily: "'Orbitron', sans-serif" }}> News </Link>
                      <Link className='d-block' to={"/contact"} style={{ color: 'white', fontFamily: "'Orbitron', sans-serif" }}>Contact</Link>

                      {(!localStorage.getItem("authToken"))
                        ?
                        <>
                        </>
                        :
                <>
                            <a href='#!' className="nav-link logout" onClick={handleLogout} style={{color:'white', fontFamily: "'Orbitron', sans-serif" }}>Logout</a>
                            <Link to="/cart" className="sidecartlogo" style={{ fontFamily: "'Orbitron', sans-serif" }}><img width='40px' height='40px' src={Cart} alt='' style={{ borderRadius: '50px' }} /></Link>
                            <span
                              className='badgeCart'
                              style={{
                                width: '30px',
                                height: '30px',
                                backgroundColor: 'transparent',
                                color: 'white',
                                position: 'absolute',
                                borderRadius: '20px',
                                marginLeft: '-15px'

                              }}
                          >{data.length}</span>

                        </>
                      }

                    </div>
                  </div>
                  <div onClick={openNav} className='sideMenu btn'  >
                  </div>


                </div>
          <div className="collapse navbar-collapse" id="navbarSupportedContent" >
            <div className="d-flex  flex-column  align-items-center w-100 " >
                    <ul className="navbar-nav navItems" >
                      <li className="nav-item active" >
                        <Link to={"/"} className="nav-link  " style={{ fontFamily: "'Orbitron', sans-serif" }}>Home </Link>
                </li>
                <li className="nav-item " >
                        <Link to={"/about"} className="nav-link " style={{ fontFamily: "'Orbitron', sans-serif" }}> About </Link>
                </li>
                <li className="nav-item " >
                        <Link to={"/medici"} className="nav-link " style={{ fontFamily: "'Orbitron', sans-serif" }}> Medicine </Link>
                </li>
                <li className="nav-item " >
                        <Link to={"/news"} className="nav-link " style={{ fontFamily: "'Orbitron', sans-serif" }}> News </Link>
                </li>
                <li className="nav-item " >
                        <Link to={"/contact"} className="nav-link " style={{ fontFamily: "'Orbitron', sans-serif" }}>Contact</Link>
                      </li >

                        {(!localStorage.getItem("authToken"))
                          ?
                        <li style={{ fontFamily: "'Orbitron', sans-serif" }} className="nav-item " >
                        <Link className="nav-link " id='login' to='/login'>
                              Login
                          </Link>
                        </li>
                        :
                        <>
                        <li style={{ fontFamily: "'Orbitron', sans-serif" }} className="nav-item " >                        
                            <Link className="nav-link logout" onClick={handleLogout} style={{ fontFamily: "'Orbitron', sans-serif" }}>Logout</Link>
                          </li>
                  <li style={{ left: '90%', position: 'fixed', zIndex: '1', fontFamily: "'Orbitron', sans-serif", borderRadius: '20px' }} >
                            <Link to="/cart" className="nav-link cartlogo" style={{ fontFamily: "'Orbitron', sans-serif" }}><img width='50px' height='50px' src={Cart} alt='' style={{ borderRadius: '50px' }} /></Link>
                          </li>
                  <span
                    className='badgeCart'
                    style={{
                      width: '30px',
                      height: '30px',
                      backgroundColor: 'transparent',
                      color: 'purple',
                      position: 'fixed',
                      left: '95%',
                      zIndex: '1',

                    }}
                  >{data.length}</span>
                        </>
                        }
                      
                    </ul>
                  </div>

          </div>
        </nav>
    </>
  )
}


